import { render, staticRenderFns } from "./DH.vue?vue&type=template&id=2833080d&scoped=true"
import script from "./DH.vue?vue&type=script&lang=js"
export * from "./DH.vue?vue&type=script&lang=js"
import style0 from "./DH.vue?vue&type=style&index=0&id=2833080d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833080d",
  null
  
)

export default component.exports